import React from "react";

export default function SectionCard({
  title,
  description,
  children,
  actions = null,
  className = "",
}) {
  return (
    <section
      className={`rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900 ${className}`}
    >
      <div className="mb-5 flex items-start justify-between gap-4">
        <div>
          <h2 className="font-bold text-slate-950 dark:text-slate-50">
            {title}
          </h2>

          {description ? (
            <p className="mt-1 text-sm leading-6 text-slate-500 dark:text-slate-400">
              {description}
            </p>
          ) : null}
        </div>

        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>

      {children}
    </section>
  );
}